import { createApi } from '@reduxjs/toolkit/query/react'
import axiosBaseQuery from 'api/axiosBaseQuery'
import { IApiResponse, LookupOption } from 'api/types'

const lookupApi = createApi({
  reducerPath: 'lookupApi',
  baseQuery: axiosBaseQuery({
    baseUrl: process.env.REACT_APP_BASE_URL ?? ''
  }),
  endpoints: (build) => ({
    getCountries: build.query<LookupOption[], void>({
      query: () => ({
        url: '/public/lookup/countries',
        method: 'GET',
        includeAuth: false
      }),
      transformResponse: (resp: IApiResponse<LookupOption[]>) => resp.data
    }),
    getStates: build.query<LookupOption[], string>({
      query: (countryId) => ({
        url: `/public/lookup/states?countryId=${countryId}`,
        method: 'GET',
        includeAuth: false
      }),
      transformResponse: (resp: IApiResponse<LookupOption[]>) => resp.data
    }),
    getCities: build.query<LookupOption[], string>({
      query: (stateId) => ({
        url: `/public/lookup/cities?stateId=${stateId}`,
        method: 'GET',
        includeAuth: false
      }),
      transformResponse: (resp: IApiResponse<LookupOption[]>) => resp.data
    }),
    getDistricts: build.query<LookupOption[], string>({
      query: (stateId) => ({
        url: `/public/lookup/districts?stateId=${stateId}`,
        method: 'GET',
        includeAuth: false
      }),
      transformResponse: (resp: IApiResponse<LookupOption[]>) => resp.data
    }),
    getTalukas: build.query<LookupOption[], string>({
      query: (districtId) => ({
        url: `/public/lookup/talukas?districtId=${districtId}`,
        method: 'GET',
        includeAuth: false
      }),
      transformResponse: (resp: IApiResponse<LookupOption[]>) => resp.data
    }),
    /**
     * Generic dynamic-form lookup. Returns a list of `{value, label}` for any of:
     * USER, PROJECT, PLOT, CUSTOMER, BROKER, LEAD.
     */
    getModuleLookup: build.query<{ value: string, label: string }[], string>({
      query: (module) => ({
        url: `/lookup/${module}`,
        method: 'GET'
      }),
      transformResponse: (resp: IApiResponse<{ value: string, label: string }[]>) =>
        resp.data
    })
  })
})

export const {
  useGetCountriesQuery,
  useGetStatesQuery,
  useGetCitiesQuery,
  useGetDistrictsQuery,
  useGetTalukasQuery,
  useGetModuleLookupQuery
} = lookupApi

export default lookupApi
